import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { push } from 'connected-react-router';

interface TestComponentProps {
  title: string;
  onClick: () => void;
  valueFromReduxState?: string;
  push?: (path: any) => void;
}

class TestComponent extends Component<TestComponentProps> {
  props: any;
  render(): JSX.Element {
    return (
      <React.Fragment>
        {this.props.valueFromReduxState}
        <Button data-button-title title={this.props.title} onClick={this.props.onClick} />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state: any) {
  return { valueFromReduxState: state.articles.valueFromReduxState };
}

export default connect(mapStateToProps, { push })(TestComponent);
